import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import TeacherLogin from "@/pages/TeacherLogin";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import VerifyEmail from "@/pages/VerifyEmail";
import { Terms, Privacy } from "@/pages/Legal";
import Instrukcja from "@/pages/Instrukcja";
import StatusPage from "@/pages/Status";
import Unsubscribe from "@/pages/Unsubscribe";
import TeacherDashboard from "@/pages/TeacherDashboard";
import Questions from "@/pages/Questions";
import SessionLive from "@/pages/SessionLive";
import TeacherSettings from "@/pages/TeacherSettings";
import AdminPanel from "@/pages/AdminPanel";
import StudentJoin from "@/pages/StudentJoin";
import StudentQuiz from "@/pages/StudentQuiz";
import StudentErrorBoundary from "@/components/StudentErrorBoundary";
import StudentResults from "@/pages/StudentResults";
import MaintenanceBanner from "@/components/MaintenanceBanner";
import FeedbackButton from "@/components/FeedbackButton";
import { ConfirmProvider } from "@/components/ConfirmDialog";
import { getToken } from "@/lib/api";

function RequireTeacher({ children }) {
  return getToken() ? children : <Navigate to="/teacher/login" replace />;
}

function App() {
  return (
    <div className="App min-h-screen">
      <Toaster position="top-right" richColors />
      <BrowserRouter>
        <ConfirmProvider>
          <MaintenanceBanner />
          <FeedbackButton />
          <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/teacher/login" element={<TeacherLogin />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/instrukcja" element={<Instrukcja />} />
          <Route path="/status" element={<StatusPage />} />
          <Route path="/unsubscribe" element={<Unsubscribe />} />
          <Route
            path="/teacher"
            element={
              <RequireTeacher>
                <TeacherDashboard />
              </RequireTeacher>
            }
          />
          <Route
            path="/teacher/questions"
            element={
              <RequireTeacher>
                <Questions />
              </RequireTeacher>
            }
          />
          <Route
            path="/teacher/session/:sessionId"
            element={
              <RequireTeacher>
                <SessionLive />
              </RequireTeacher>
            }
          />
          <Route
            path="/teacher/settings"
            element={
              <RequireTeacher>
                <TeacherSettings />
              </RequireTeacher>
            }
          />
          <Route
            path="/teacher/admin"
            element={
              <RequireTeacher>
                <AdminPanel />
              </RequireTeacher>
            }
          />
          <Route path="/join" element={<StudentJoin />} />
          <Route path="/quiz/:code/:studentId" element={<StudentErrorBoundary><StudentQuiz /></StudentErrorBoundary>} />
          <Route path="/results/:code/:studentId" element={<StudentResults />} />
        </Routes>
        </ConfirmProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
